export default function() {
  'ngInject';

  function statusClasses({ type, webinarSessionKeys, fetched }) {
    const nonWebinar = type === 'otherExternal' || type === 'boosterLearnExternal';
    const missingSession = type === 'gtwEventExternal' && (!webinarSessionKeys || !webinarSessionKeys.length);
    const dataFetched = fetched;

    if (nonWebinar) return 'label-basic badge-basic';
    if (missingSession) return 'label-warning badge-warning';
    if (dataFetched) return 'label-primary badge-primary';
    return 'label-danger badge-danger';
  }

  function getText({ zoomWebinarId, zoomMeetingId, webexType, webinarKey, programId, type }) {
    if (type === 'acpenExternal') return 'ACPEN Webinar';
    if (type === 'cnfExternal') return 'Conference.io';
    if (type === 'webexExternal') return 'Webex Event';
    if (type === 'otherExternal') return 'Other Url';
    if (type === 'boosterLearnExternal') return 'BoosterLearn';
    if (zoomWebinarId) return 'Zoom Webinar';
    if (zoomMeetingId) return 'Zoom Meeting';
    if (webinarKey) return 'GoTo Webinar';
    if (webexType === 'training') return 'Webex Training';
    if (webexType === 'event') return 'Webex Event';

    return 'Webinar';
  }

  return {
    restrict: 'A',
    scope: {
      external: '<'
    },
    link: function(scope, element) {
      const color = statusClasses(scope.external);
      const text = getText(scope.external);

      element.addClass(color);
      element[0].innerHTML = text;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/externalStatusLabel/index.js